import React from "react";
import { FormattedMessage } from "react-intl";
import ContextualLinksRow from "@components/countryPage/CityCard/ContextualLinks/ContextualLinksRow/contextualLinksRow";
import styles from "./contextualLinks.module.scss";
import locales from "@translations/locales";

const ContextualLinks = ({ city, locale }) => {
  const searchUrl = locales[locale].default
    ? `${process.env.HOMEPAGE_URL}/accommodation/${city}`
    : `${process.env.HOMEPAGE_URL}/${locale}/accommodation/${city}`;
  const rentTypeProperty = "rent-type[]=property";
  const rentTypeUnit = "rent-type[]=unit";
  const housingTypeResidence = "housing-type[]=residence";
  const translationId = "cities_page.cities_card.contextual_links";
  const apartmentsForRent = [
    { 
      key: `${translationId}.apartments_for_rent`, 
      href:`${searchUrl}?${rentTypeProperty}` 
    },
    { 
      key: `${translationId}.1_bedroom`, 
      href:`${searchUrl}?${rentTypeProperty}&bedrooms[]=1` 
    },
    { 
      key: `${translationId}.2_bedrooms`,
      href:`${searchUrl}?${rentTypeProperty}&bedrooms[]=2` 
    },
    { 
      key: `${translationId}.3_bedrooms`,
      href:`${searchUrl}?${rentTypeProperty}&bedrooms[]=3` 
    },
    { 
      key: `${translationId}.4_bedrooms`,
      href:`${searchUrl}?${rentTypeProperty}&bedrooms[]=4` 
    },
  ];
  const roomsForRent = [
    { 
      key: `${translationId}.rooms_for_rent`,
      href:`${searchUrl}?${rentTypeUnit}` 
    },
    { 
      key: `${translationId}.1_bedroom`,
      href:`${searchUrl}?${rentTypeUnit}&bedrooms[]=1` 
    },
    { 
      key: `${translationId}.2_bedrooms`,
      href:`${searchUrl}?${rentTypeUnit}&bedrooms[]=2` 
    },
    { 
      key: `${translationId}.3_bedrooms`,
      href:`${searchUrl}?${rentTypeUnit}&bedrooms[]=3` 
    },
    { 
      key: `${translationId}.4_bedrooms`,
      href:`${searchUrl}?${rentTypeUnit}&bedrooms[]=4` 
    },
  ];
  const studiosForRent = [
    { 
      key: `${translationId}.studios_for_rent`,
      href:`${searchUrl}?${rentTypeProperty}&bedrooms[]=0` 
    },
  ]
  const studentAccommodation = [
    { 
      key: `${translationId}.student_accommodation`,
      href:`${searchUrl}?${housingTypeResidence}` 
    },
  ];

  return (
    <div className={styles.links}>
      <nav className={styles.links__description}>
        <h3><FormattedMessage id={`${translationId}.find_the_right_home_for_you`} /></h3>
        {
          [apartmentsForRent, roomsForRent, studiosForRent, studentAccommodation].map((links, index) => (
            <ContextualLinksRow links={links} key={index} />
          ))
        }
      </nav>
    </div>
  );
};

export default ContextualLinks;
